<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'ClubSection',

  components: {
    MyHeader,
    SideNav,
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'Club search',
          route: {name: 'club_search'},
        },
        {
          title: 'Club suggestion',
          route: {name: 'club_suggestion'},
        },
        {
          title: 'Last clubs',
          route: {name: 'last_clubs'},
        },
        {
          title: 'Active clubs',
          route: {name: 'active_clubs'},
        },
        {
          title: 'Complainees',
          route: {name: 'clubs_complainees'},
        },
      ];
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  min-width: 600px;
  max-width: 600px;
  padding-top: 1em;
}
</style>
